<template>
  <div>
    <div class="row">
      <div class="col-md-8">
        <Heading title="Health" />
      </div>
    </div>

    <div class="row row-space-4">
      <div class="col-md-6 align-self-center">
        <div class="p-4">
          <img src="@/assets/img/error.svg" class="img-fluid" v-if="hasProblems || errorHandling" />
          <img src="@/assets/img/peace.svg" class="img-fluid" v-else />
        </div>
      </div>
      <div class="col-md-6 align-self-center">
        <div v-if="hasProblems">
          <Alert class="alert-attention mb-4" title="Password protection" icon="IconImportant" v-if="shopObj.password_enabled">
            <p>AMP requires public store without password protection to work.</p>
            <p>
              <strong>Solution:</strong> <ExternalLink :href="'https://' + shopObj.myshopify_domain + '/admin/online_store/preferences'" text="Click here to view password protection settings in Shopify Dashboard and disable password protection" class="ml-1 alert-link" />
            </p>
            <p>Once you have disabled the password protection, please refresh this page. It may take up to 15 minutes to reflect the updates.</p>
            <p class="small mb-0"><em>This impacts performance of your AMP store.</em></p>
          </Alert>

          <Alert class="alert-attention mb-4" title="Multiple-amphtml references" icon="IconImportant" v-if="vAuto.amp">
            <p>We have detected more than one 'amphtml' references in your Shopify theme. <u>Have you installed other AMP apps before?</u></p>
            <p>
              <strong>Solution:</strong> <ExternalLink :href="'https://' + shopObj.myshopify_domain + '/admin/themes'" text="Click here to view your theme in Shopify Dashboard and remove code from old AMP apps." class="ml-1 alert-link" />
            </p>
            <p class="small mb-0"><em>This impacts performance of your AMP store.</em></p>
          </Alert>

          <div class="card bs" v-if="vAuto.amp">
            <div class="card-body">
              <p class="font-weight-normal">Once you have resolved the issues, please submit a request to validate the fix.</p>

              <ProcessButton type="favicon" submitText="Validate the fix" successText="Your fix is being validated." />
            </div>
          </div>
        </div>
        <div v-else>
          <Alert v-if="!errorHandling" class="alert-success" icon="IconCheck">
            <p class="mb-0"><strong>No intervention needed.</strong></p>
          </Alert>
          <Alert :class="ehData.css" icon="IconImportant" :title="ehData.title" titleLink="error_monitoring" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es'
import { mapState } from 'vuex'

import ProcessButton from '@/components/ProcessButton'

export default {
  components: {
    ProcessButton
  },
  computed: {
    ...mapState([ 'vAuto', 'shopObj' ]),
    hasProblems: function () {
      if (this.vAuto.amp) return true
      if (this.shopObj.password_enabled) return true

      return false
    },
    errorHandling: function () {
      const errors = get(this.vAuto, 'tests.errors') || []
      return errors.length > 0
    },
    ehData: function () {
      if (this.hasProblems && this.errorHandling) {
        return {
          css: 'alert-attention',
          title: 'We have found other errors on your store &rsaquo;'
        }
      }

      if (!this.hasProblems && this.errorHandling) {
        return {
          css: 'alert-attention',
          title: 'We have found potential errors on your store &rsaquo;'
        }
      }

      return {
        css: 'alert-info',
        title: 'We have enabled Error Monitoring on your store &rsaquo;'
      }
    }
  }
}
</script>
